import math from "core/math";

function fillPolygon2(context, pointsArray, fillColor, strokeColor, lineWidth) {
  if (pointsArray.length <= 0) return;
  context.beginPath();
  context.moveTo(pointsArray[0].x, pointsArray[0].y);
  for (var i = 0; i < pointsArray.length; i++) {
    context.lineTo(pointsArray[i].x, pointsArray[i].y);
  }
  if (strokeColor !== null && strokeColor !== undefined)
    context.strokeStyle = strokeColor;
  if (lineWidth !== null && lineWidth !== undefined)
    context.lineWidth = lineWidth;

  if (fillColor !== null && fillColor !== undefined) {
    context.fillStyle = fillColor;
    context.fill();
  }
  context.closePath();
  //context.restore();
}

function fillPolygon(
  context,
  pointsArray,
  fillColor,
  strokeColor,
  lineWidth = 0
) {
  if (pointsArray.length <= 0) return;
  context.beginPath();
  context.moveTo(pointsArray[0].x, pointsArray[0].y);
  for (var i = 0; i < pointsArray.length; i++) {
    context.lineTo(pointsArray[i].x, pointsArray[i].y);
  }

  if (lineWidth !== null && lineWidth !== undefined)
    context.lineWidth = lineWidth;

  if (strokeColor !== null && strokeColor !== undefined) {
    context.strokeStyle = strokeColor;
    context.stroke();
  }

  if (fillColor !== null && fillColor !== undefined) {
    context.fillStyle = fillColor;
    context.fill();
  }
  context.closePath();
  //context.restore();
}

/**
 * Draw a series of joined lines, starting at `start` and then going to each point in `points`.
 * @public
 * @method drawPolygon
 * @memberof Drawing
 *
 * @param {CanvasRenderingContext2D} context - Target context
 * @param {HTMLElement} element - The DOM Element to draw on
 * @param {Object} start - `{ x, y }` in either pixel or canvas coordinates.
 * @param {Object[]} points - `[{ x, y }]` An array of points in either pixel or canvas coordinates.
 * @param {Object} options - See {@link path}
 * @param {String} [coordSystem='pixel']
 * @returns {undefined}
 */
export default function(
  context,
  element,
  points,
  options,
  coordSystem = "pixel"
) {
  if (coordSystem === "pixel") {
    points = points.map(p => math.coordinate.pixelToCanvas(element, p));
  }
  fillPolygon(
    context,
    points,
    options.fillStyle,
    options.strokeColor,
    options.lineWidth
  );
}
